// pages/PasswordReset.js
import RequestPasswordReset from "../components/PasswordScreen/RequestPasswordReset";
import Footer from "../components/HomeScreen/Footer";

const PasswordReset = () => {
  return (
    <>
      <RequestPasswordReset />
      <Footer />
    </>
  );
}
export default PasswordReset;
